import * as React from "react";

import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { setToggleAllAudios } from "../../../../store/audio-slice";

import volumeUp from "../../../../assets/img/audio/volume_up.svg";
import volumeDown from "../../../../assets/img/audio/volume_down.svg";

const AudioVolumeSpeaker: React.FC = () => {
  const toggleAllAudios = useAppSelector(
    (state) => state.audio.toggleAllAudios
  );
  const dispatch = useAppDispatch();

  return (
    <button
      type="button"
      className="sound_settings"
      onClick={() => {
        dispatch(setToggleAllAudios());
      }}
    >
      {toggleAllAudios && <img src={volumeUp} alt="" />}
      {!toggleAllAudios && <img src={volumeDown} alt="" />}
    </button>
  );
};

export default AudioVolumeSpeaker;
